<app-grid-expense style="padding: 20px; margin-right:20px" [gridColumns]="gridColumns"
               [gridRecords]="gridRecords"
               (refresh)="onRefresh()"
               (loading)="onLoadingDetail($event)"
               (cellPrepared)="onCellPrepared($event)"
               [employeeDataSource]="employeesNotQuit" [expenseTypeDataSource]="expenseTypeDataSource"
               [projectIds]="projectIds"
               [visibleIndexProject]="3"
               [(showTransportColumn)]="showTransportColumn"
               [newStatusId]="3"
               [newCategoryId]="9"
               (showExpenseGrid)="onShowExpenseGrid($event)"
               (editingStart)="onEditingStart($event)" >
</app-grid-expense>